import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQuery } from "../api"
import {
  AdvisorSession,
  AdvisorSessionDetail,
  AdvisorSessionsResponse,
  WebsiteChatConversationsResponse
} from "../../types"
import {
  ADVISOR_CONVERSATIONS_ENDPOINT,
  ADVISOR_CONVERSATION_DETAIL_ENDPOINT
} from "../../common/constants"

export interface GetAdvisorSessionsParams {
  page: number
  limit: number
}

export const advisorApi = createApi({
  reducerPath: "advisorApi",
  baseQuery,
  endpoints: builder => ({
    getAdvisorSessions: builder.query<
      AdvisorSessionsResponse,
      GetAdvisorSessionsParams
    >({
      query: ({ page, limit }) => ({
        url: ADVISOR_CONVERSATIONS_ENDPOINT,
        params: { page, limit, subjectType: "subscription" }
      })
    }),
    getAdvisorSessionBySubscription: builder.query<
      { conversation: AdvisorSession | null },
      string
    >({
      query: subscriptionId => ({
        url: `${ADVISOR_CONVERSATIONS_ENDPOINT}/${subscriptionId}`,
        params: { subjectType: "subscription" }
      })
    }),
    getAdvisorSession: builder.query<AdvisorSessionDetail, string>({
      query: id => ({
        url: `${ADVISOR_CONVERSATION_DETAIL_ENDPOINT}/${id}`,
        params: { subjectType: "subscription" }
      })
    }),
    getWebsiteChatSessions: builder.query<
      WebsiteChatConversationsResponse,
      GetAdvisorSessionsParams
    >({
      query: ({ page, limit }) => ({
        url: ADVISOR_CONVERSATIONS_ENDPOINT,
        params: { page, limit, subjectType: "session" }
      })
    }),
    getWebsiteChatSession: builder.query<AdvisorSessionDetail, string>({
      query: id => ({
        url: `${ADVISOR_CONVERSATION_DETAIL_ENDPOINT}/${id}`,
        params: { subjectType: "session" }
      })
    }),
    getAiTokenUsage: builder.query<
      AiTokenUsageResponse,
      { since: string; until: string }
    >({
      query: ({ since, until }) => ({
        url: "/api/v1/advisor/admin/usage",
        params: { since, until }
      })
    })
  })
})

export interface AiTokenUsageResponse {
  totalTokens: number
  totalInputTokens: number
  totalOutputTokens: number
  totalMessages: number
  conversationCount: number
}

export const {
  useGetAdvisorSessionsQuery,
  useLazyGetAdvisorSessionsQuery,
  useGetAdvisorSessionQuery,
  useGetAdvisorSessionBySubscriptionQuery,
  useGetWebsiteChatSessionsQuery,
  useLazyGetWebsiteChatSessionsQuery,
  useGetWebsiteChatSessionQuery,
  useGetAiTokenUsageQuery
} = advisorApi
